//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

// Elevation FW Components

import { Routes } from '@angular/router';
import { AmsGuard, AuthGuard } from '@polygon/core';
import { businessAppRouteMatcher, dashboardAppRouteMatcher, formsAppRouteMatcher, listsAppRouteMatcher } from './app.routes.matcher';
import { errorRouteMatcher } from './error.routes.matcher';

const baseRoutes: Routes = [
    {
        matcher: dashboardAppRouteMatcher,
        loadChildren: () => import('./dashboard.module').then(m => m.DashboardAppModule),
    },
    {
        matcher: listsAppRouteMatcher,
        loadChildren: () => import('./lists.module').then(m => m.ListsAppModule),
    },
    {
        matcher: businessAppRouteMatcher,
        loadChildren: () => import('./business.module').then(m => m.BusinessAppModule),
    },
    {
        matcher: formsAppRouteMatcher,
        loadChildren: () => import('./forms.module').then(m => m.FormsAppModule),
    },
    {
        path: 'error',
        loadComponent: () => import('@polygon/components').then(m => m.PriErrorComponent),
    },
    {
        path: '',
        loadChildren: () => import('../../custom-code/custom.routes').then(m => m.customRoutes)
    },
    {
        path: '**',
        loadComponent: () => import('@polygon/components').then(m => m.EmptyComponent),
    }
]

//@ts-ignore
export const appRoutes: Routes = [
    {
        matcher: errorRouteMatcher,
        loadComponent: () => import('@polygon/components').then(m => m.PriErrorComponent),
    },
    {
        path: ':account/:subscription',
        loadComponent: () => import('@polygon/shell').then(m => m.LayoutRootComponent),
        canActivate: [AuthGuard, AmsGuard],
        children: baseRoutes
    },
    {
        path: 'popup',
        outlet: 'popup',
        loadComponent: () => import('@polygon/shell').then(m => m.ModalRouterInjectorComponent),
        children: baseRoutes
    },
    {
        path: 'panel',
        outlet: 'panel',
        loadComponent: () => import('@polygon/shell').then(m => m.PanelRouterInjectorComponent),
        children: baseRoutes
    },
    {
        path: '',
        canActivate: [AuthGuard, AmsGuard],
        loadComponent: () => import('@polygon/components').then(m => m.EmptyComponent),
    },
    {
        path: '**',
        redirectTo: ''
    }
];
